/* REBITE theme — UI behaviour + Shopify AJAX cart drawer */
(function () {
  "use strict";

  var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reducedMotion) document.documentElement.classList.add("reduced");

  function money(pence) {
    var v = pence / 100;
    var s = v.toFixed(2).replace(/\.00$/, "");
    return "£" + s;
  }

  /* ---------- sticky header ---------- */
  var header = document.querySelector(".site-header");
  window.addEventListener("scroll", function () {
    if (header) header.classList.toggle("scrolled", window.scrollY > 8);
  }, { passive: true });

  /* ---------- FAQ / accordions ---------- */
  document.addEventListener("click", function (e) {
    var q = e.target.closest(".faq-q");
    if (!q) return;
    var item = q.parentElement;
    var answer = item.querySelector(".faq-a");
    var isOpen = item.classList.contains("open");
    var scope = item.closest(".faq, .accordion") || item.parentElement;
    scope.querySelectorAll(".faq-item.open").forEach(function (o) {
      o.classList.remove("open");
      var a = o.querySelector(".faq-a");
      if (a) a.style.maxHeight = null;
    });
    if (!isOpen && answer) {
      item.classList.add("open");
      answer.style.maxHeight = answer.scrollHeight + "px";
    }
  });

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(msg) {
    var t = document.getElementById("toast");
    if (!t) return;
    t.textContent = msg;
    t.classList.add("show");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove("show"); }, 2600);
  }

  /* ============================================================
     CART DRAWER (Shopify AJAX Cart API)
     ============================================================ */
  var drawer = document.getElementById("cartDrawer");
  var overlay = document.getElementById("cartOverlay");
  var cartState = null;

  function openCart() {
    if (!drawer) return;
    drawer.classList.add("open");
    overlay.classList.add("open");
    drawer.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove("open");
    overlay.classList.remove("open");
    drawer.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }

  function fetchCart() {
    return fetch("/cart.js").then(function (r) { return r.json(); });
  }

  function changeLine(key, qty) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty }),
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); });
  }

  function addToCart(variantId, qty) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty || 1 }] }),
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return refreshCart();
    });
  }

  function shipProgressHTML(cart) {
    var goal = Number(drawer.dataset.threshold || 4000);
    var sub = cart.items_subtotal_price;
    if (sub === 0) {
      return '<div class="msg">Free UK shipping on orders over <b>' + money(goal) + '</b></div><div class="ship-bar"><i style="width:0%"></i></div>';
    }
    var pct = Math.min(100, (sub / goal) * 100);
    var remaining = goal - sub;
    var msg = remaining > 0
      ? "You're <b>" + money(remaining) + "</b> away from <b>free shipping</b>"
      : "<b>Free shipping unlocked</b> — nice one.";
    return '<div class="msg">' + msg + '</div><div class="ship-bar"><i style="width:' + pct + '%"></i></div>';
  }

  function upsellHTML(cart) {
    var vid = drawer.dataset.upsellVariant;
    if (!vid || cart.item_count === 0) return "";
    var inCart = cart.items.some(function (i) { return String(i.variant_id) === vid; });
    if (inCart) return "";
    var goal = Number(drawer.dataset.threshold || 4000);
    var price = Number(drawer.dataset.upsellPrice);
    var sub = cart.items_subtotal_price;
    var kicker = (sub < goal && sub + price >= goal)
      ? "Add this &amp; unlock FREE shipping"
      : (sub >= goal ? "Complete the system" : "Pairs with your tools");
    return (
      '<div class="upsell">' +
      '<img src="' + drawer.dataset.upsellImage + '" alt="' + drawer.dataset.upsellTitle + '">' +
      "<div>" +
      '<div class="u-kicker">' + kicker + "</div>" +
      "<b>" + drawer.dataset.upsellTitle + " — " + money(price) + "</b>" +
      '<button class="upsell-add" data-quick-add="' + vid + '">Add to order</button>' +
      "</div></div>"
    );
  }

  function renderCart(cart) {
    if (!drawer) return;
    cartState = cart;
    var itemsEl = document.getElementById("cartItems");
    var footEl = document.getElementById("cartFoot");
    var progEl = document.getElementById("shipProgress");
    progEl.innerHTML = shipProgressHTML(cart);

    document.querySelectorAll(".cart-count").forEach(function (b) {
      b.textContent = cart.item_count;
      b.classList.toggle("show", cart.item_count > 0);
    });
    var headCount = document.getElementById("cartHeadCount");
    if (headCount) headCount.textContent = cart.item_count ? "(" + cart.item_count + ")" : "";

    if (cart.item_count === 0) {
      itemsEl.innerHTML =
        '<div class="cart-empty"><span class="eyebrow">Your cart is empty</span>' +
        "<p>The habit won't break itself.</p>" +
        '<a class="btn btn-solid" href="/collections/all">Shop the tools <span class="arr">&rarr;</span></a></div>';
      footEl.innerHTML = "";
      return;
    }

    itemsEl.innerHTML =
      cart.items
        .map(function (item) {
          var img = item.image
            ? item.image + (item.image.indexOf("?") > -1 ? "&" : "?") + "width=160&height=160&crop=center"
            : "";
          return (
            '<div class="cart-item">' +
            (img ? '<img src="' + img + '" alt="">' : "<div></div>") +
            "<div>" +
            '<div class="ci-name"><a href="' + item.url + '">' + item.product_title + "</a></div>" +
            '<div class="ci-price">' + money(item.final_price) + "</div>" +
            '<div class="qty">' +
            '<button data-line="' + item.key + '" data-q="' + (item.quantity - 1) + '" aria-label="Decrease quantity">&minus;</button>' +
            "<span>" + item.quantity + "</span>" +
            '<button data-line="' + item.key + '" data-q="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
            "</div></div>" +
            '<div class="ci-right">' +
            '<div class="ci-total">' + money(item.final_line_price) + "</div>" +
            '<button class="ci-remove" data-line="' + item.key + '" data-q="0">Remove</button>' +
            "</div></div>"
          );
        })
        .join("") + upsellHTML(cart);

    var goal = Number(drawer.dataset.threshold || 4000);
    var note = cart.items_subtotal_price >= goal
      ? "Free shipping · 30-day money-back guarantee"
      : "Shipping calculated at checkout · 30-day guarantee";
    footEl.innerHTML =
      '<div class="cart-sub"><span>Subtotal</span><span>' + money(cart.items_subtotal_price) + "</span></div>" +
      '<div class="cart-note">' + note + "</div>" +
      '<a class="btn btn-solid btn-block" href="/checkout">Checkout <span class="arr">&rarr;</span></a>' +
      '<a class="cart-note" style="display:block;text-align:center;margin-top:12px;text-decoration:underline;text-underline-offset:3px;" href="/cart">View cart page</a>';
  }

  function refreshCart() {
    return fetchCart().then(renderCart);
  }

  /* ---------- events ---------- */
  document.addEventListener("click", function (e) {
    var openBtn = e.target.closest("[data-open-cart]");
    if (openBtn) { e.preventDefault(); refreshCart().then(openCart); return; }

    var quick = e.target.closest("[data-quick-add]");
    if (quick) {
      e.preventDefault();
      quick.disabled = true;
      addToCart(quick.dataset.quickAdd, 1)
        .then(function () { toast("Added to cart"); openCart(); })
        .catch(function (err) { toast((err && err.description) || "Couldn't add to cart"); })
        .finally(function () { quick.disabled = false; });
      return;
    }

    var lineBtn = e.target.closest("[data-line]");
    if (lineBtn) {
      e.preventDefault();
      changeLine(lineBtn.dataset.line, Number(lineBtn.dataset.q));
      return;
    }
  });

  if (overlay) overlay.addEventListener("click", closeCart);
  var closeBtn = document.getElementById("cartClose");
  if (closeBtn) closeBtn.addEventListener("click", closeCart);
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeCart(); });

  /* product form (PDP) */
  document.addEventListener("submit", function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    var variantId = form.querySelector('[name="id"]').value;
    var qtyInput = form.querySelector('[name="quantity"]');
    var qty = qtyInput ? Number(qtyInput.value) : 1;
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;
    addToCart(variantId, qty)
      .then(function () { toast("Added to cart"); openCart(); })
      .catch(function (err) { toast((err && err.description) || "Couldn't add to cart"); })
      .finally(function () { if (btn) btn.disabled = false; });
  });

  /* PDP qty stepper + thumbs */
  document.addEventListener("click", function (e) {
    var step = e.target.closest("[data-step]");
    if (step) {
      var input = document.getElementById("pdpQty");
      if (input) input.value = Math.max(1, Number(input.value) + Number(step.dataset.step));
      return;
    }
    var thumb = e.target.closest("#thumbs button[data-src]");
    if (thumb) {
      var mainImg = document.getElementById("mainImg");
      if (mainImg) mainImg.src = thumb.dataset.src;
      document.querySelectorAll("#thumbs button").forEach(function (b) { b.classList.remove("active"); });
      thumb.classList.add("active");
    }
  });

  /* ---------- animations ---------- */
  window.addEventListener("DOMContentLoaded", function () {
    refreshCart();

    var swap = document.querySelector(".swap-word");
    if (swap && !reducedMotion) {
      var words = (swap.dataset.words || "CLICK.,SLIDE.,SPIN.,ROLL.").split(",");
      var i = 0;
      setInterval(function () {
        swap.classList.add("out");
        setTimeout(function () {
          i = (i + 1) % words.length;
          swap.textContent = words[i];
          swap.classList.remove("out");
        }, 280);
      }, 2200);
    }

    if (reducedMotion || !window.gsap) {
      document.querySelectorAll(".reveal").forEach(function (el) {
        el.style.opacity = 1;
        el.style.transform = "none";
      });
      return;
    }
    gsap.registerPlugin(ScrollTrigger);
    var heroBits = document.querySelectorAll(".hero [data-hero]");
    if (heroBits.length) {
      gsap.fromTo(heroBits, { y: 40, opacity: 0 }, { y: 0, opacity: 1, duration: 1, ease: "power3.out", stagger: 0.09, delay: 0.12 });
    }
    document.querySelectorAll(".reveal").forEach(function (el) {
      gsap.fromTo(el, { y: 28, opacity: 0 }, { y: 0, opacity: 1, duration: 0.9, ease: "power3.out", scrollTrigger: { trigger: el, start: "top 88%" } });
    });
    document.querySelectorAll("[data-stagger]").forEach(function (grid) {
      gsap.fromTo(grid.children, { y: 36, opacity: 0 }, { y: 0, opacity: 1, duration: 0.8, ease: "power3.out", stagger: 0.08, scrollTrigger: { trigger: grid, start: "top 85%" } });
    });
  });
})();
